import NewsItem from "./newsItemEntity";

export default class NewsItemDto {
    public limit: number;
    public skip: number;
    public total: number;
    public newsItems: NewsItem[];
  
    constructor() {
      this.limit = 0;
      this.skip = 0;
      this.total = 0;

      this.newsItems = [];
    }
  }


// WEBPACK FOOTER //
// ./src/api/newsItemDto.ts